import React, { useEffect, useState, useRef } from 'react';
import ApexCharts from 'apexcharts';
import { useTheme } from '@mui/material/styles';

const DonutChart = ({ portfolioData }) => {
  const theme = useTheme(); // Access the theme for dynamic styling

  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        type: 'donut',
        events: {
          dataPointMouseEnter: (event, chartContext, config) => {
            const label = document.querySelector(
              `#label-${config.dataPointIndex}`
            );
            if (label) {
              label.style.backgroundColor = theme.palette.action.hover;
              label.style.borderRadius = '5px';
              label.style.padding = '5px';
            }
          },
          dataPointMouseLeave: (event, chartContext, config) => {
            const label = document.querySelector(
              `#label-${config.dataPointIndex}`
            );
            if (label) {
              label.style.backgroundColor = 'transparent';
              label.style.padding = '0';
            }
          },
        },
      },
      labels: [],
      colors: [
        '#FF4560',
        '#008FFB',
        '#00E396',
        '#FEB019',
        '#775DD0',
        '#FF66C4',
        '#00D9E9',
        '#FEB100',
      ],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 300,
            },
            legend: {
              position: 'right',
            },
          },
        },
      ],
      legend: {
        position: 'right',
        formatter: (label, opts) =>
          `<span id="label-${opts.seriesIndex}" style="cursor: pointer;">${label}</span>`,
        labels: {
          colors: theme.palette.text.primary,
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: false,
            },
          },
          expandOnClick: false,
        },
      },
      stroke: {
        width: 0,
      },
      title: {
        text: undefined,
      },
      tooltip: {
        theme: 'dark',
      },
      states: {
        hover: {
          filter: {
            type: 'lighten',
            value: 0.15,
          },
        },
      },
    },
  });
  const chartContainerRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    const cryptocurrencies = portfolioData?.cryptocurrencies ?? [];
    if (!cryptocurrencies.length) {
      setChartData((prevData) => ({
        ...prevData,
        series: [],
        options: {
          ...prevData.options,
          labels: [],
        },
      }));
      return;
    }
    const seriesData = cryptocurrencies.map((crypto) => Number(crypto.percentage) || 0);
    const labelData = cryptocurrencies.map((crypto) => crypto.name || '');

    setChartData((prevData) => ({
      ...prevData,
      series: seriesData,
      options: {
        ...prevData.options,
        labels: labelData,
      },
    }));
  }, [portfolioData]);

  useEffect(() => {
    if (!chartContainerRef.current) {
      return;
    }

    chartInstanceRef.current?.destroy();
    const chartOptions = {
      ...chartData.options,
      series: chartData.series,
    };
    const chart = new ApexCharts(chartContainerRef.current, chartOptions);
    chart.render();
    chartInstanceRef.current = chart;

    return () => {
      chart.destroy();
      chartInstanceRef.current = null;
    };
  }, [chartData]);

  return <div ref={chartContainerRef} style={{ marginTop: '20px' }} />;
};

export default DonutChart;
